import { darken, getContrastRatio, type Theme } from '@mui/material/styles';

// WCAG standard for text contrast
export const MIN_CONTRAST_RATIO = 4.5;

export function getAccessibleTextColor(theme: Theme, bgColor: string, textColor: string): string {
    let adjustedTextColor = textColor;
    let contrast = getContrastRatio(bgColor, adjustedTextColor);

    // Darken text color until contrast is good enough
    while (contrast < MIN_CONTRAST_RATIO) {
        adjustedTextColor = darken(adjustedTextColor, 0.1);
        contrast = getContrastRatio(bgColor, adjustedTextColor);

        if (contrast >= MIN_CONTRAST_RATIO) {
            return adjustedTextColor;
        }
    }

    // Fallback: black or white text color
    return getContrastRatio(bgColor, theme.palette.common.black) >= MIN_CONTRAST_RATIO
        ? theme.palette.common.black
        : theme.palette.common.white;
};
